import React from 'react';
import ComponentField from '../../form/ComponentField';
import createForm from "./Form";

class AllergenForm extends React.Component {

    render() {
        return (
            <form onSubmit={ this.props.handleSubmit }>
                <div className="row form-row">
                    <div className="col-md-2">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name={this.props.componentConfig.idfield}
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Kód"
                        />    
                    </div>
                    <div className="col-md-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="token"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Token"
                        />    
                    </div>
                    <div className="col-md-5">
                        <ComponentField
                            getFieldProps={this.props.getFieldProps}
                            componentConfig={this.props.componentConfig}
                            name="name"
                            values={this.props.values}
                            setFieldValue={this.props.setFieldValue}
                            label="Megnevezés"
                        />    
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(AllergenForm);
